
export const userColumns = [
    {
        field: "user",
        headerName: "Username",
        flex: 1,
        renderCell: (params) => {
            return (
                <div className="cellWithImg">
                    <img
                        className="cellImg"
                        src={params.row.img ? params.row.img : process.env.PUBLIC_URL + '/images/default.jpg'}
                        alt="avatar"
                    />
                    {params.row.username}
                </div>
            );
        }
    },
    { field: "fullname", headerName: "Full Name", flex: 0.7 },
    { field: "email", headerName: "Email", flex: 1 },
    { field: "phone", headerName: "Phone", flex: 0.7 },
];








